import {extractDocs} from '~/utils/transform-payload'

export function usePerks() {
  const sdk = usePayloadSdk()

  const fetch = async () => {
    const response = await sdk.find({
      collection: 'perks',
      depth: 1, // Populates icon relationship
      limit: 1000, // Get all perks
    })

    return extractDocs(response)
  }

  return {
    fetch,
  }
}
